import { CoreGridInput, GridFilter, GridSort } from 'skladon-types';

export class CoreGridMapper {
    public static mapFilters(
        gridFilters: GridFilter[][] = [],
        columnNames: Map<string, string>,
        booleanValues: string[] = []
    ): GridFilter[][] {
        const filters: { column: string; operator: string; value: string }[][] = [];
        gridFilters.forEach((orFilters) => {
            const andFilters: { column: string; operator: string; value: string }[] = [];
            orFilters.forEach((filter) => {
                const column = columnNames.get(filter.column);
                if (column) {
                    const isBoolean = booleanValues.includes(column);
                    let { value } = filter;
                    if (isBoolean) {
                        // from core
                        value = Boolean(value);
                    } else if (typeof filter.value === 'boolean') {
                        // to core
                        value = Number(value);
                    }
                    andFilters.push({
                        column,
                        operator: filter.operator,
                        value
                    });
                }
            });
            if (andFilters.length) {
                filters.push(andFilters);
            }
        });

        return filters;
    }

    public static mapSorts(gridSorts: GridSort[] = [], columnNames: Map<string, string>): GridSort[] {
        const sorts: { column: string; direction: string }[] = [];
        gridSorts.forEach((sort) => {
            const column = columnNames.get(sort.column);
            if (column) {
                sorts.push({
                    column,
                    direction: sort.direction
                });
            }
        });
        return sorts;
    }

    public static mapColumns(gridColumns: string[] = [], columnNames: Map<string, string>): string[] {
        return gridColumns.map((column) => columnNames.get(column)).filter((column): column is string => !!column);
    }

    public static mapGrid(
        grid: CoreGridInput,
        columnMapping: { [key: string]: string },
        maxRows: number,
        booleanValues: string[] = []
    ): CoreGridInput {
        const coreColumnNames = new Map(Object.entries(columnMapping));
        return {
            columns: CoreGridMapper.mapColumns(grid.columns, coreColumnNames),
            filters: CoreGridMapper.mapFilters(grid.filters, coreColumnNames, booleanValues),
            items: grid.items > maxRows ? maxRows : grid.items,
            page: grid.page,
            sorts: CoreGridMapper.mapSorts(grid.sorts, coreColumnNames)
        };
    }

    public static omitColumns(data: object, columnMapping: { [key: string]: string }, columns: string[] = []) {
        const coreColumnNamesMap = new Map(Object.entries(columnMapping));
        const convertedColumns = columns.map((column) => coreColumnNamesMap.get(column));
        if (columns.length === 0) {
            return data;
        }
        const newObject: { [key: string]: unknown } = { ...data };
        Object.keys(data).forEach((key) => {
            if (!convertedColumns.includes(key)) {
                delete newObject[key];
            }
        });

        return newObject;
    }
}
